exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntr[data-v-22339468]:hover {\n  background: #e7e3e3;\n}\n", ""]);

// exports
